import React from "react";

const About = () => {
  return (
    <div
      name="about"
      className="w-full h-screen bg-gradient-to-b from-gray-800 to-black text-white"
    >
      <div className="max-w-screen-lg p-4 mx-auto flex-col justify-center w-full h-full">
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-gray-500">
            About
          </p>
        </div>
        <p className="text-lg mt-20">
          {" "}
          I started my coding and development journey with HTML and CSS back in
          2017. I was so fascinated when I first discovered the marquee tag, it
          was really magical. To be honest, it took so many months for me to
          understand CSS at that time because it seemed hard, and the properties
          and centering divs, overlapping sections just frustrated me then I
          thought I should jump directly to the good part of the Bootstrap where
          I can get pre-built NavBars, sections, designs and more. So, I thought
          that would be my thing and started exploring Bootstrap. It was really
          amazing learning experience and eventually, I learned the CSS
          framework without having much knowledge of CSS. Then I jumped to
          JavaScript because I thought it was enough to make websites without
          functionalities, and now I have added one. That’s how I started
          learning Vanilla JS and later ES6 syntaxes.{" "}
        </p>

        <br />

        <p className="text-lg">
          JavaScript is not a language you can learn overnight, you have to give
          time otherwise you will mess up the whole thing. So, I gave time and
          learned simple concepts like loops, variables, and Arrow functions.
          Later, I jumped to advanced concepts like Template Literals,
          Async/Await, Promises, Mapping, and that stuff. I thought that now is
          the time to explore Front-End Frameworks and discovered React in that
          journey and also experimented with CSS frameworks like TailWind and Chakra UI. I know the journey is endless and full
          of possibilities.
        </p>
      </div>
    </div>
  );
};

export default About;
